import Box from "@material-ui/core/esm/Box";
import Button from "@material-ui/core/esm/Button";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PrimaryButton, SecondaryButton } from 'components/Button';
import useStyles from './StepperStyles';
export default function RouterStepper({
  onBackButtonClick,
  onForwardButtonClick,
  altForwardButtonText,
  hasForwardButtonDisabled = false,
  isForwardButtonLoading = false,
  isFinalStep = false
}) {
  const {
    t
  } = useTranslation();
  const {
    stepperRoot,
    spacingRight
  } = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: stepperRoot
  }, /*#__PURE__*/React.createElement(Button, {
    className: spacingRight,
    onClick: onBackButtonClick,
    disabled: isForwardButtonLoading
  }, t('buttons.cancel')), isFinalStep ? /*#__PURE__*/React.createElement(PrimaryButton, {
    disabled: hasForwardButtonDisabled,
    onClick: onForwardButtonClick,
    loading: isForwardButtonLoading
  }, altForwardButtonText || t('buttons.go_forward')) : /*#__PURE__*/React.createElement(SecondaryButton, {
    disabled: hasForwardButtonDisabled,
    onClick: onForwardButtonClick,
    loading: isForwardButtonLoading
  }, altForwardButtonText || t('buttons.go_forward')));
}
RouterStepper.defaultProps = {
  isForwardButtonLoading: false
};